var _rect, _rect2, _path, _rect3, _rect4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrypt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44.2,
    height: 44.2,
    x: 5.9,
    y: 5.9,
    stroke: "currentColor",
    strokeWidth: 1.3,
    rx: 2.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 6.125,
    x: 22.75,
    y: 28.875,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "m42 21-1.95-6.454a2 2 0 0 0-1.914-1.421H17.864a2 2 0 0 0-1.914 1.421L14 21"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 3.25,
    x: 11.5,
    y: 40.375,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 1.625
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 3.25,
    x: 11.5,
    y: 21.125,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 1.625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M14.75 24.5v15.75M41.875 24.5v15.75M14 30.625h-.875a1.75 1.75 0 1 0 0 3.5H14m28 0h.875a1.75 1.75 0 1 0 0-3.5H42"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypt);
export default __webpack_public_path__ + "static/media/crypt.6ce6531de197a7a050d71cd08cb8002f.svg";
export { ForwardRef as ReactComponent };